export const APP_CONSTANTS = {
    CURRENT_TIME: "2025-06-08 22:35:30",
    DEFAULT_USER: "Gps-Gaurav",
    API_BASE_URL: "http://localhost:8000/api",
    STORAGE_KEYS: {
        USER_INFO: 'userInfo',
        CART_ITEMS: 'cartItems',
        SHIPPING_ADDRESS: 'shippingAddress'
    },
    TIME_FORMAT: 'YYYY-MM-DD HH:mm:ss'
};

export const ERROR_MESSAGES = {
    STORAGE_LOAD: 'Error loading data from localStorage',
    STORAGE_SAVE: 'Error saving data to localStorage',
    API_ERROR: 'Error communicating with API',
    INVALID_DATA: 'Invalid data received'
};